// @ts-nocheck

import { isEmpty } from 'lodash';

import {
  REPORTING_ADVANCED_FILTERS_SET_ENABLED,
  REPORTING_CHANGE_CONTEXTUAL_DISCOVERY_REPORT_STATUS,
  REPORTING_CHANGE_COVERAGE_STUDY_REPORT_STATUS,
  REPORTING_CHANGE_GEOLOOKALIKE_STATUS,
  REPORTING_CHANGE_PDF_REPORT_STATUS,
  REPORTING_CLEAN_PDF_REPORT_STATUS_BY_KEY,
  REPORTING_INSIGHTS_RESET_STATS,
  REPORTING_INSIGHTS_SET_GROUP_BY_CONFIG,
  REPORTING_INSIGHTS_SET_METRICS_CONFIG,
  REPORTING_INSIGHTS_SET_RAW_DATA,
  REPORTING_INSIGHTS_SET_STATS,
  REPORTING_PROGRESS_RESET_KPI_STATS,
  REPORTING_PROGRESS_RESET_STATS,
  REPORTING_PROGRESS_SET_GRAPH_CONFIG,
  REPORTING_PROGRESS_SET_KPI_STATS,
  REPORTING_PROGRESS_SET_KPI_STATS_STATUS,
  REPORTING_PROGRESS_SET_METRIC_AND_KPI,
  REPORTING_PROGRESS_SET_STATS,
  REPORTING_RESET_MAP_DATA,
  REPORTING_RESET_SECTIONS_STATS,
  REPORTING_RESET_STORE,
  REPORTING_SET_AGGREGATED_STATS,
  REPORTING_SET_CAMPAIGN_EVENTS,
  REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ANALYTICAL_VIEW,
  REPORTING_SET_CAMPAIGN_ITEM_DETAILS_CAMPAIGN_STATUS,
  REPORTING_SET_CAMPAIGN_ITEM_DETAILS_EVENT_FAMILIES,
  REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ONLY_TOP_CAMPAIGNS,
  REPORTING_SET_CAMPAIGN_ITEM_DETAILS_SEARCH_TEXT,
  REPORTING_SET_CAMPAIGN_ITEM_DETAILS_STATS,
  REPORTING_SET_CAMPAIGNS_SCREENS,
  REPORTING_SET_CARTOGRAPHY,
  REPORTING_SET_CARTOGRAPHY_MAP_CONFIG,
  REPORTING_SET_CHANGE_LOG_DATA,
  REPORTING_SET_COUNTRIES_WITH_EVENTS,
  REPORTING_SET_CUSTOM_EVENTS,
  REPORTING_SET_DEFAULT_MAP_BOUNDING_BOX,
  REPORTING_SET_DOWNLOAD_INSIGHTS_DATA,
  REPORTING_SET_DOWNLOAD_SUMMARY_DATA,
  REPORTING_SET_EVENTS_BY_GEOHASH,
  REPORTING_SET_FOOTFALL_ATTRIBUTION_STATS,
  REPORTING_SET_HEATMAP_DATA,
  REPORTING_SET_INDIVIDUAL_EVENTS,
  REPORTING_SET_MAP_EVENTS,
  REPORTING_SET_MAP_SELECTED_EVENTS,
  REPORTING_SET_SECTIONS_VISIBILITY,
  REPORTING_SET_SELECTED_CAMPAIGNS,
  REPORTING_SET_SHARED_REPORTS,
  REPORTING_SET_STATIC_MODE,
  REPORTING_SET_STATS_GROUPS,
  REPORTING_SET_TABLE_STATS_BY_STEP,
  REPORTING_SET_TOTAL_AVG_MODE,
  REPORTING_SET_TOTAL_AVG_MODES,
  REPORTING_TOGGLE_CAMPAIGN_LINES_INFO,
  REPORTING_TOGGLE_MAP_LOADING
} from '@/store/actions/reporting.actions';
import {
  REPORTING_ADVANCED_FILTER_DELETE_MAP,
  REPORTING_ADVANCED_FILTER_SET_MAPS
} from '@/store/actions/reportingAdvancedFilter.actions';
import { shortcutsConfig } from '@/ts-modules/reporting/Header/Shortcuts/shortcutsConfig';

const initialStore = {
  advancedFiltersEnabled: true,
  aggregatedStats: {},
  cartography: [],
  cartographyMapConfig: {},
  changeLogData: null,
  contextualDiscoveryReportStatus: {},
  countriesIncludeHouseHoldImpactsEvents: false,
  countriesWithEvents: [],
  coverageStudyReportStatus: {},
  customEvents: {
    actions: [],
    clicks: [],
    impressions: []
  },
  doohStats: null,
  downloadInsightsData: {
    result: null,
    status: 'finished'
  },
  downloadSummaryData: {
    format: 'excel',
    result: null,
    status: 'finished'
  },
  eventsByGeoH: {},
  geoLookALikeStatus: {},
  heatmapData: {},
  individualEvents: {},
  insights: {
    config: {
      groupByConfig: {},
      metricsConfig: {}
    },
    rawData: {},
    stats: {}
  },
  mapEvents: [],
  mapLoading: {
    reportingFootfallAttributionInsightsMap: false,
    reportingMap: false
  },
  pdfReportStatus: {},
  screens: [],
  sections: {
    footfallAttributionInsightsByStore: {},
    insights: {},
    map: {},
    progress: {
      kpiStats: {}
    },
    stats: {
      footfallAttribution: ['day', 'attrVids', 'attrType'],
      stats: ['day'],
      viewability: ['day']
    },
    summary: {
      aggregatedStats: null,
      aggregatedStatsByCampaign: {
        result: {},
        status: 'pending'
      },
      analyticalViewStats: {
        lastDays: [],
        lastHours: []
      },
      campaignItemDetails: {
        analyticalViewEnabled: false,
        filters: {
          campaignStatus: null,
          eventFamilies: null,
          searchText: '',
          trendPeriod: 10
        },
        onlyTopCampaigns: false,
        stats: {
          result: {},
          status: 'pending'
        }
      }
    },
    table: {}
  },
  sectionsVisibility: shortcutsConfig.reduce(
    (acc, shortcutConfig) => ({
      ...acc,
      [shortcutConfig.id]: true
    }),
    {}
  ),
  selectedCampaigns: [],
  sharedReports: null,
  showCampaignLinesInfo: false,
  staticMode: false,
  tableStatsByStep: null,
  totalAvgModes: {
    footfallAttribution: 'avg',
    stats: 'avg'
  }
};

const filterNoneMapInsightsStats = insightsStats =>
  Object.entries(insightsStats).reduce((acc, [key, stats]) => {
    if (!key.includes('_map_')) {
      return {
        ...acc,
        [key]: stats
      };
    }
    return acc;
  }, {});

const actionsMap = {
  [REPORTING_SET_AGGREGATED_STATS]: (store, action) => {
    const { section, stats } = action.data;
    return {
      ...store,
      ...(!section && { aggregatedStats: stats }),
      sections: {
        ...store.sections,
        ...(section && {
          [section]: {
            ...store.sections[section],
            aggregatedStats: stats
          }
        })
      }
    };
  },
  [REPORTING_SET_COUNTRIES_WITH_EVENTS]: (store, action) => {
    const { countriesWithEvents } = action.data;
    return {
      ...store,
      countriesWithEvents
    };
  },
  [REPORTING_SET_DEFAULT_MAP_BOUNDING_BOX]: (store, action) => {
    const { defaultBoundingBox } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        map: {
          ...store.map,
          defaultBoundingBox
        }
      }
    };
  },
  [REPORTING_SET_TABLE_STATS_BY_STEP]: (store, action) => {
    const { tableStatsByStep } = action.data;
    return {
      ...store,
      tableStatsByStep
    };
  },
  [REPORTING_SET_SELECTED_CAMPAIGNS]: (store, action) => {
    const { selectedCampaigns } = action.data;
    return {
      ...store,
      selectedCampaigns
    };
  },
  [REPORTING_SET_CHANGE_LOG_DATA]: (store, action) => {
    const { changeLogData } = action.data;
    return {
      ...store,
      changeLogData
    };
  },
  [REPORTING_SET_TOTAL_AVG_MODES]: (store, action) => {
    const { totalAvgModes } = action.data;
    return {
      ...store,
      totalAvgModes
    };
  },
  [REPORTING_SET_TOTAL_AVG_MODE]: (store, action) => {
    const { mode, type } = action.data;
    return {
      ...store,
      totalAvgModes: {
        ...store.totalAvgModes,
        [type]: mode
      }
    };
  },
  [REPORTING_SET_FOOTFALL_ATTRIBUTION_STATS]: (store, action) => {
    const { footfallAttributionStats } = action.data;
    return {
      ...store,
      footfallAttributionStats
    };
  },
  [REPORTING_TOGGLE_MAP_LOADING]: (store, action) => {
    const { mapId, toggle } = action.data;
    return {
      ...store,
      mapLoading: {
        ...store.mapLoading,
        [mapId]: toggle
      }
    };
  },
  [REPORTING_SET_CAMPAIGN_EVENTS]: (store, action) => {
    const { campaignEvents } = action.data;
    return {
      ...store,
      campaignEvents
    };
  },
  [REPORTING_SET_HEATMAP_DATA]: (store, action) => {
    const { heatmapData, mapId } = action.data;
    return {
      ...store,
      heatmapData: {
        ...store.heatmapData,
        [mapId]: heatmapData
      }
    };
  },
  [REPORTING_SET_INDIVIDUAL_EVENTS]: (store, action) => {
    const { individualEvents, mapId } = action.data;
    return {
      ...store,
      individualEvents: {
        ...store.individualEvents,
        [mapId]: individualEvents
      }
    };
  },
  [REPORTING_SET_EVENTS_BY_GEOHASH]: (store, action) => {
    const { eventsByGeoH, mapId } = action.data;
    return {
      ...store,
      eventsByGeoH: {
        ...store.eventsByGeoH,
        [mapId]: eventsByGeoH
      }
    };
  },
  [REPORTING_RESET_MAP_DATA]: (store, action) => {
    const { mapId } = action.data;
    return {
      ...store,
      eventsByGeoH: {
        ...store.eventsByGeoH,
        [mapId]: {}
      },
      heatmapData: {
        ...store.heatmapData,
        [mapId]: {}
      },
      individualEvents: {
        ...store.individualEvents,
        [mapId]: {}
      }
    };
  },
  [REPORTING_SET_MAP_EVENTS]: (store, action) => {
    const { mapEvents } = action.data;
    return {
      ...store,
      mapEvents
    };
  },
  [REPORTING_SET_MAP_SELECTED_EVENTS]: (store, action) => {
    const { mapSelectedEvents } = action.data;
    return {
      ...store,
      mapSelectedEvents
    };
  },
  [REPORTING_SET_STATIC_MODE]: (store, action) => {
    const { staticMode } = action.data;
    return {
      ...store,
      staticMode
    };
  },
  [REPORTING_SET_CAMPAIGNS_SCREENS]: (store, action) => {
    const { screens } = action.data;
    return {
      ...store,
      screens
    };
  },
  [REPORTING_SET_SHARED_REPORTS]: (store, action) => {
    const { sharedReports } = action.data;
    return {
      ...store,
      sharedReports
    };
  },
  [REPORTING_PROGRESS_RESET_KPI_STATS]: store => {
    return {
      ...store,
      sections: {
        ...store.sections,
        progress: {
          ...store.sections.progress,
          kpiStats: {
            ...initialStore.sections.progress.kpiStats
          }
        }
      }
    };
  },
  [REPORTING_PROGRESS_SET_KPI_STATS]: (store, action) => {
    const { groupBy, grouped: groupedStats, ...restStats } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        progress: {
          ...store.sections.progress,
          kpiStats: {
            ...store.sections.progress.kpiStats,
            [groupBy]: {
              ...store.sections.progress.kpiStats[groupBy],
              grouped: groupedStats,
              ...(!isEmpty(restStats) && {
                [Object.keys(restStats)[0]]: restStats[Object.keys(restStats)[0]]
              })
            }
          }
        }
      }
    };
  },
  [REPORTING_PROGRESS_SET_KPI_STATS_STATUS]: (store, action) => {
    const { groupBy, status } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        progress: {
          ...store.sections.progress,
          kpiStats: {
            ...store.sections.progress.kpiStats,
            [groupBy]: {
              ...store.sections.progress.kpiStats[groupBy],
              status
            }
          }
        }
      }
    };
  },
  [REPORTING_INSIGHTS_SET_GROUP_BY_CONFIG]: (store, action) => {
    const { insightGroupByConfig, insightId } = action.data;
    return {
      ...store,
      insights: {
        ...store.insights,
        config: {
          ...store.insights.config,
          groupByConfig: {
            ...store.insights.config.groupByConfig,
            [insightId]: insightGroupByConfig
          }
        }
      }
    };
  },
  [REPORTING_INSIGHTS_SET_METRICS_CONFIG]: (store, action) => {
    const { metricsConfig } = action.data;
    return {
      ...store,
      insights: {
        ...store.insights,
        config: {
          ...store.insights.config,
          metricsConfig
        }
      }
    };
  },
  [REPORTING_INSIGHTS_SET_RAW_DATA]: (store, action) => {
    const { section, state } = action.data;
    return {
      ...store,
      insights: {
        ...store.insights,
        rawData: {
          ...store.insights.rawData,
          [section]: state
        }
      }
    };
  },
  [REPORTING_ADVANCED_FILTERS_SET_ENABLED]: (store, action) => {
    const { enabled } = action.data;
    return {
      ...store,
      advancedFiltersEnabled: enabled
    };
  },
  [REPORTING_INSIGHTS_SET_STATS]: (store, action) => {
    const { insightsId, stats } = action.data;
    return {
      ...store,
      insights: {
        ...store.insights,
        stats: {
          ...store.insights.stats,
          [insightsId]: stats
        }
      }
    };
  },
  [REPORTING_INSIGHTS_RESET_STATS]: store => {
    return {
      ...store,
      insights: {
        ...store.insights,
        stats: {}
      }
    };
  },
  [REPORTING_TOGGLE_CAMPAIGN_LINES_INFO]: (store, action) => {
    const { option } = action.data;
    return {
      ...store,
      showCampaignLinesInfo: option
    };
  },
  [REPORTING_RESET_STORE]: () => {
    return {
      ...initialStore
    };
  },
  [REPORTING_RESET_SECTIONS_STATS]: store => {
    return {
      ...store,
      sections: initialStore.sections
    };
  },
  [REPORTING_SET_CAMPAIGN_ITEM_DETAILS_STATS]: (store, action) => {
    const { result, status } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        summary: {
          ...store.sections.summary,
          campaignItemDetails: {
            ...store.sections.summary.campaignItemDetails,
            stats: {
              result,
              status
            }
          }
        }
      }
    };
  },
  [REPORTING_SET_CAMPAIGN_ITEM_DETAILS_EVENT_FAMILIES]: (store, action) => {
    const { eventFamilies } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        summary: {
          ...store.sections.summary,
          campaignItemDetails: {
            ...store.sections.summary.campaignItemDetails,
            filters: {
              ...store.sections.summary.campaignItemDetails.filters,
              eventFamilies
            }
          }
        }
      }
    };
  },
  [REPORTING_SET_CAMPAIGN_ITEM_DETAILS_CAMPAIGN_STATUS]: (store, action) => {
    const { campaignStatus } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        summary: {
          ...store.sections.summary,
          campaignItemDetails: {
            ...store.sections.summary.campaignItemDetails,
            filters: {
              ...store.sections.summary.campaignItemDetails.filters,
              campaignStatus
            }
          }
        }
      }
    };
  },
  [REPORTING_SET_CAMPAIGN_ITEM_DETAILS_SEARCH_TEXT]: (store, action) => {
    const { searchText } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        summary: {
          ...store.sections.summary,
          campaignItemDetails: {
            ...store.sections.summary.campaignItemDetails,
            filters: {
              ...store.sections.summary.campaignItemDetails.filters,
              searchText
            }
          }
        }
      }
    };
  },
  [REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ONLY_TOP_CAMPAIGNS]: (store, action) => {
    const { enabled } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        summary: {
          ...store.sections.summary,
          campaignItemDetails: {
            ...store.sections.summary.campaignItemDetails,
            onlyTopCampaigns: enabled
          }
        }
      }
    };
  },
  [REPORTING_SET_CAMPAIGN_ITEM_DETAILS_ANALYTICAL_VIEW]: (store, action) => {
    const { enabled } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        summary: {
          ...store.sections.summary,
          campaignItemDetails: {
            ...store.sections.summary.campaignItemDetails,
            analyticalViewEnabled: enabled
          }
        }
      }
    };
  },
  [REPORTING_SET_DOWNLOAD_SUMMARY_DATA]: (store, action) => {
    const { format, result, status } = action.data;
    return {
      ...store,
      downloadSummaryData: {
        format,
        result,
        status
      }
    };
  },
  [REPORTING_SET_DOWNLOAD_INSIGHTS_DATA]: (store, action) => {
    const { result, status } = action.data;
    return {
      ...store,
      downloadInsightsData: {
        result,
        status
      }
    };
  },
  [REPORTING_SET_SECTIONS_VISIBILITY]: (store, action) => {
    const { sectionsVisibility } = action.data;
    return {
      ...store,
      sectionsVisibility
    };
  },
  [REPORTING_ADVANCED_FILTER_SET_MAPS]: store => {
    return {
      ...store,
      insights: {
        ...store.insights,
        stats: filterNoneMapInsightsStats(store.insights.stats)
      }
    };
  },
  [REPORTING_ADVANCED_FILTER_DELETE_MAP]: store => {
    return {
      ...store,
      insights: {
        ...store.insights,
        stats: filterNoneMapInsightsStats(store.insights.stats)
      }
    };
  },
  [REPORTING_CHANGE_CONTEXTUAL_DISCOVERY_REPORT_STATUS]: (store, action) => {
    return {
      ...store,
      contextualDiscoveryReportStatus: action.data
    };
  },
  [REPORTING_CHANGE_COVERAGE_STUDY_REPORT_STATUS]: (store, action) => {
    return {
      ...store,
      coverageStudyReportStatus: action.data
    };
  },
  [REPORTING_CHANGE_GEOLOOKALIKE_STATUS]: (store, action) => {
    return {
      ...store,
      geoLookALikeStatus: action.data
    };
  },
  [REPORTING_CHANGE_PDF_REPORT_STATUS]: (store, action) => {
    return {
      ...store,
      pdfReportStatus: {
        ...store.pdfReportStatus,
        [action.data.key]: {
          ...store.pdfReportStatus[action.data.key],
          ...action.data.value
        }
      }
    };
  },
  [REPORTING_CLEAN_PDF_REPORT_STATUS_BY_KEY]: (store, action) => {
    const { key } = action.data;
    const pdfReportStatus = structuredClone(store.pdfReportStatus);
    if (pdfReportStatus[key]) {
      delete pdfReportStatus[key];
    }
    return {
      ...store,
      pdfReportStatus
    };
  },
  [REPORTING_PROGRESS_RESET_STATS]: store => {
    return {
      ...store,
      sections: {
        ...store.sections,
        progress: {
          ...initialStore.sections.progress
        }
      }
    };
  },
  [REPORTING_PROGRESS_SET_STATS]: (store, action) => {
    const { chartType, stats } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        progress: {
          ...store.sections.progress,
          [chartType]: stats
        }
      }
    };
  },
  [REPORTING_SET_STATS_GROUPS]: (store, action) => {
    const { groups, tableType } = action.data;
    return {
      ...store,
      sections: {
        ...store.sections,
        stats: {
          ...store.sections.stats,
          [tableType]: groups
        }
      }
    };
  },
  [REPORTING_PROGRESS_SET_METRIC_AND_KPI]: (store, action) => {
    return {
      ...store,
      progressEventsBy: action.data
    };
  },
  [REPORTING_PROGRESS_SET_GRAPH_CONFIG]: (store, action) => {
    return {
      ...store,
      progressGraphs: {
        ...store.progressGraphs,
        [action.data.key]: action.data.config
      }
    };
  },
  [REPORTING_SET_CARTOGRAPHY]: (store, action) => {
    const { cartography } = action.data;
    return {
      ...store,
      cartography
    };
  },
  [REPORTING_SET_CARTOGRAPHY_MAP_CONFIG]: (store, action) => {
    const { cartographyMapConfig } = action.data;
    return {
      ...store,
      cartographyMapConfig: {
        ...store.cartographyMapConfig,
        ...cartographyMapConfig
      }
    };
  },
  [REPORTING_SET_CUSTOM_EVENTS]: (store, action) => {
    const { customEvents } = action.data;
    return {
      ...store,
      customEvents
    };
  }
};

export default function reducer(store = initialStore, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(store, action) : store;
}
